import { render, staticRenderFns } from "./caracterizacion-accidentalidad.vue?vue&type=template&id=156ed034&scoped=true&"
import script from "./caracterizacion-accidentalidad.vue?vue&type=script&lang=js&"
export * from "./caracterizacion-accidentalidad.vue?vue&type=script&lang=js&"
import style0 from "./caracterizacion-accidentalidad.vue?vue&type=style&index=0&id=156ed034&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156ed034",
  null
  
)

export default component.exports